<template>
  <el-slider
    :class="[dangerClass, warningClass, successClass]"
    v-model="slider"
    :show-tooltip="false"
    :step="5"
    show-stops
    :marks="marks"
    :disabled="disabled"
  >
  </el-slider>
</template>

<script>
export default {
  props: {
    slider: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: 0,
      marks: {
        0: "0",
        5: "1",
        10: "2",
        15: "3",
        20: "4",
        25: "5",
        30: "6",
        35: "7",
        40: "8",
        45: "9",
        50: "10",
        55: "11",
        60: "及格",
        65: "13",
        70: "14",
        75: "15",
        80: "良好",
        85: "17",
        90: "18",
        95: "优秀",
        100: "20"
      }
    };
  },
  computed: {
    dangerClass() {
      return this.slider < 60 ? "zhu-danger-color" : "";
    },
    warningClass() {
      return 55 < this.slider && this.slider < 80 ? "zhu-warning-color" : "";
    },
    successClass() {
      return this.slider > 75 ? "zhu-success-color" : "";
    }
  },
  watch: {
    slider(val) {
      this.value = val;
    },
    value(val) {
      this.$emit("update:slider", val);
    }
  }
};
</script>

<style lang="less">
.zhu-danger-color {
  .el-slider__bar {
    background-color: #f56c6c !important;
  }
  .el-slider__button {
    border: 2px solid #f56c6c;
  }
}
.zhu-warning-color {
  .el-slider__bar {
    background-color: #e6a23c !important;
  }
  .el-slider__button {
    border: 2px solid #e6a23c;
  }
}
.zhu-success-color {
  .el-slider__bar {
    background-color: #13ce66 !important;
  }
  .el-slider__button {
    border: 2px solid #13ce66;
  }
}
</style>
